const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
const lowerFirst = (word) => (word ? word.charAt(0).toLocaleLowerCase() + word.slice(1) : '');

/**
 * Presence line of a person who is not online: "zuletzt online heute, 14:32",
 * "… gestern, 09:10" or "… 28. Okt., 16:05". `value` is the user's
 * `lastOnlineAt` from the group info or a `userStatus` event. Without one
 * (older server, never seen) it stays the plain "Inactive".
 */
export function lastOnlineText(value, strings = {}, language, now = new Date()) {
  const d = value ? new Date(value) : null;
  if (!d || Number.isNaN(d.getTime())) return strings.inactive || 'Inactive';

  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  let day;
  if (d >= today) {
    day = lowerFirst(strings.today || 'Today');
  } else if (d >= yesterday) {
    day = lowerFirst(strings.yesterday || 'Yesterday');
  } else {
    const opts = { day: 'numeric', month: 'short' };
    if (d.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
    try {
      day = d.toLocaleDateString(language ? String(language).split('-')[0] : undefined, opts);
    } catch (e) {
      day = `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${opts.year ? d.getFullYear() : ''}`;
    }
  }
  return (strings.last_online || 'last seen {{when}}').replace('{{when}}', `${day}, ${time}`);
}
